import React, { useState, useEffect, useMemo } from "react";
import { useSelector} from "react-redux";
import { Button, Container, Row, Table, Spinner, OverlayTrigger, Tooltip, Col,Form} from 'react-bootstrap';
import {envAwarePost,slidingQueryComparision} from '../../../util/util'
import './exerciseProgress.css'
import ExerciseGraph from './exerciseGraph.js'
import {useHistory} from 'react-router-dom';
import SetExerciseGraph from "./setExerciseGraph"
import { useInView } from 'react-intersection-observer'
import { useDebounceCallback } from '@react-hook/debounce'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as faIcons  from '@fortawesome/free-solid-svg-icons'

const ExerciseTable = ({exercise,formatRepsWeights})=>{
  const [sort,setSort] = useState('desc')
  return (
    <div className="col-xl-6">
      <h4 style={{marginTop:'1em'}}>{exercise.exerciseName}</h4>
      <Table  className="exercise_progress_table">
        <thead>
          <th 
            tabIndex={0}
            style={{cursor:'pointer'}} 
            onClick={()=>{
              setSort(p=>p==='desc'?'asc':'desc')
            }}
          >
            Date <FontAwesomeIcon icon={faIcons[sort==='desc'?'faCaretDown':'faCaretUp']}/>
          </th>
          <th>Sets</th>
          <th>Reps</th>
          <th>Weight</th>
          <th>RPE</th>
        </thead>
        {exercise.exerciseData.sort((a,b)=>{
          switch(sort){
            case 'desc': return a.date < b.date ? 1 : -1
            case 'asc': return a.date < b.date ? -1 : 1
          }
        }).map( progress => (
          <tbody>
            <tr>
                <td>{progress.longDate}</td>
                <td>{progress.actualSets}/{progress.expectedSets}</td> 
                {((progress.actualRepsString).split(",")).length > 1 
                  ? formatRepsWeights(progress.actualRepsString, progress.expectedRepsString)
                  : <td>{progress.actualRepsString}/{progress.expectedRepsString}</td>
                }
                {((progress.actualWeightString).split(",")).length > 1 
                  ? formatRepsWeights(progress.actualWeightString, progress.expectedWeightString)
                  : <td>{progress.actualWeightString}/{progress.expectedWeightString}</td>
                }
                {((progress.actualRPEString).split(",")).length > 1 
                  ? formatRepsWeights(progress.actualRPEString, progress.expectedRPEString)
                  : <td>{progress.actualRPEString}{progress.expectedRPEString!=="0"&&`/${progress.expectedRPEString}`}</td>
                }
            </tr>
          </tbody>
        ))}
      </Table>
    </div>
  )
}

const ViewExerciseProgress = () => {

  const history = useHistory()
  
  const [progressData,setProgressData] = useState([])

  //state/logic for infinite scroll and search
  const [query,setQuery] = useState('')
  const debouncedSearch = useDebounceCallback((q)=>{
    setQuery(q)
  },300)

  const sortedProgressData = useMemo(()=>(
    progressData.sort((a,b)=>slidingQueryComparision(a.exerciseName,b.exerciseName,query))
  ),[progressData,query])

  const infiniteScrollBlockSize = 20
  const [displayCount,setDisplayCount] = useState(infiniteScrollBlockSize)
  const { ref: scrollRef, inView } = useInView({
    /* Optional options */
    threshold: 0,
  })
  useEffect(() => {
    if (inView && displayCount < progressData.length) {
      setDisplayCount(prev=>prev + infiniteScrollBlockSize)
    }
  }, [inView])

  const slicedProgressData = useMemo(()=>(
    sortedProgressData.slice(0,displayCount)
  ),[sortedProgressData,query,displayCount])


  const [showTables, setshowTables] = useState(false);
  const [showGraphs, setshowGraphs] = useState(true);
  const [clientName, setClientName] = useState('Client')
  const [loadStatus,setLoadStatus] = useState('loading')


  // grabs the client ID from the URL
  // const clientId = window.location.href.split('=')[1]
  const url = new URL(window.location.href);
  const clientId = url.searchParams.get("client");
  const trainerId = url.searchParams.get("trainer");
  const exerciseID = url.searchParams.get("exerciseID")

  //checks account type. Is true or false 
  const isClient = useSelector((state) => state.users.current_user.account_type)==="client"

  //upon 'Graph Format' or 'Table Format' click, toggles one to show and other to hide
  const handleToggle = () => {
    setDisplayCount(infiniteScrollBlockSize)
    if (showGraphs) {
        setshowGraphs(false)
        setshowTables(true)
    } else {
        setshowGraphs(true)
        setshowTables(false)
    }
  }

  //grabs and sets clientName and progressData
  useEffect(() => {
    envAwarePost(
      'api/users/api.php/',
      {action:'getClientProfileData', client_id:clientId}
    ).then(res=>{
      if(res.success==='1'){
        setClientName(res.data.user_name)
      }
    })

    envAwarePost('api/events/api/',{
      action:'getExerciseProgressData',
      client_id:clientId
    }).then(res=>{
      if(res.success==='1'){
        const {aggregates} = res.data
        setLoadStatus('idle')
        if(exerciseID){
          setProgressData(aggregates.filter(p=>p.exerciseID == exerciseID))
        }else{
          setProgressData(aggregates)
        }
      }
    })
  }, [])

  const handlePrint = () => {
    window.print()
  }

  const formatRepsWeights = (actual, expected) => {
    // example: 1,1,1,1,1,1,1,1,1,1/4,2,2,2,4,4,4,4,4,4
    let actualArray = actual.split(",")
    let expectedArray = expected.split(",")
    let pairs = []
    actualArray.forEach((actual, index) => {
      const expected = (
        expectedArray[index] !== '0'
        ? `/${expectedArray[index]}`
        : ''
      )
      pairs.push(`${actual}${expected} \n`)
    })
    return(
      <td style={{width:"47px"}}>
        <Col>
          {pairs.map(pair => {
            return(pair)
          })}
        </Col>
      </td>
    )
  }

  // input: [{…}, {…}, {…}]  -> {…}.longDate = "Sep 27, 2021"
  // output: [{…}, {…}, {…}]
  const orderProgressByDate =(exerciseData)=> {
    let orderedProgress =exerciseData.sort(function(a,b){
      return new Date(b.longDate) - new Date(a.longDate);
    });
    return orderedProgress
  }

  return (
    <div className="pt-2 px-2 px-md-3" id="containerDiv">
      <div>
        {isClient ?<strong>My Exercise Progress</strong> :<strong>{clientName}'s Exercise Progress</strong>}
      </div>
      <hr/>
      <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
      {loadStatus==='loading'? <Spinner animation="border" variant="primary"  style={{textAlign: "center"}}  />:null}
      </div>
      {progressData.length>0 ? 
      <>
      <div className="d-flex flex-wrap align-items-start flex-md-nowrap justify-content-end">
        <Form.Control
          placeholder="Search"
          className="mr-1 mb-1"
          onChange={e=>{
            debouncedSearch(e.target.value)
          }}
          size="sm"
          defaultValue={query}
        />
        <Button 
          style={{flex:'0 0 auto'}}
          className="mr-1" 
          variant={showGraphs ? 'primary': 'light'} 
          size="sm" 
          onClick={handleToggle}
        >
          Graph Format
        </Button>
        <Button 
          style={{flex:'0 0 auto'}}
          variant={showTables ? 'primary' : 'light'} 
          size="sm" 
          onClick={handleToggle}
        >
          Table Format
        </Button>
        <Button
          className="ml-1"
          variant="outline-secondary"
          onClick={handlePrint}
          size="sm"
        >
          <i class="fa fa-print"></i>
        </Button>
      </div>
      <div style={{ display: showTables ? 'block' : 'none', height:'100%'}}>
        <Container>
          <Row>
            {slicedProgressData?.map( exercise => (
              <>
              {exercise.exerciseData.length>0 ? 
                <ExerciseTable exercise={exercise} formatRepsWeights={formatRepsWeights}/>
              :null}
              </>
            ))}
          </Row>
        </Container>
      </div>
      <div className="pt-2" style={{display: showGraphs ? 'block' : 'none'}}>
          {slicedProgressData?.map( exercise => { 
            let progressData;
            if (exercise.exerciseData.length >= 1) {
              progressData = exercise.exerciseData.sort((a,b)=>(new Date(a.shortDate) - new Date(b.shortDate)));
            }
            return (
            <>
              {exercise.exerciseData.length >= 1 ? 
                <div className="exercise__progressGraphsContainer">
                  <h4 className="exercise_progress_title">{exercise.exerciseName}</h4>
                  <div className="">
                    <SetExerciseGraph progressData = {progressData} />
                  </div>
                </div>
              :null}
            </>
            )
          }
          )}
      </div>
      {displayCount <= progressData.length &&
            <div ref={scrollRef}>
              Loading more...
            </div>
          }    
      </>
      :
      <>
        {loadStatus==='idle'? 
            <div style={{display:'flex', justifyContent:'center'}}>
            <p>There is no progress data to show</p>
          </div>
        :null}
      </>
      }
    </div>
  )
}

export default ViewExerciseProgress